<template>
    <div class="desktop-main" v-loading="loading" element-loading-text="正在加载中，请稍后。。。">
        <div class="admin-body" v-loading="downloading" element-loading-text="图片正在生成中，请稍后。。。">
            <el-form ref="form" :model="tableParams" label-width="80px" :inline="true">
                <el-form-item label="手机号">
                    <el-input v-model="tableParams.orderUserPhone" placeholder="请输入用户手机号" clearable></el-input>
                </el-form-item>
                <el-form-item label="编号">
                    <el-input v-model="tableParams.orderCode" placeholder="请输入订单编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="tableParams.orderStatus" placeholder="请选择订单状态" clearable>
                        <el-option :key="0" label="待付款" :value="0"></el-option>
                        <el-option :key="1" label="已付款" :value="1"></el-option>
                        <el-option :key="4" label="退款中" :value="4"></el-option>
                        <el-option :key="2" label="已退款" :value="2"></el-option>
                        <el-option :key="3" label="超时关闭" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单时间">
                    <el-date-picker
                        v-model="tableParams.createdTimes"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="付款时间">
                    <el-date-picker
                        v-model="tableParams.payTimes"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="退款时间">
                    <el-date-picker
                        v-model="tableParams.refundTimes"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <!-- <el-form-item label="上屏时间">
                    <el-date-picker
                        v-model="tableParams.handTimes"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item> -->
                <el-form-item label="上屏日期">
                    <el-date-picker
                        v-model="tableParams.handDates"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="排序">
                    <el-select v-model="tableParams.orderBy" placeholder="请选择排序" clearable>
                        <el-option :key="1" label="按订单创建时间" value=""></el-option>
                        <el-option :key="2" label="按上大屏时间" value="handStartDate"></el-option>
                        <el-option :key="3" label="按付款时间" value="payTime"></el-option>
                        <el-option :key="4" label="按退款时间" value="refundTime"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="退款申请">
                    <el-select v-model="tableParams.refundApplyStatus" placeholder="请选择退款申请状态" clearable>
                        <el-option :key="1" label="待处理的退款申请" :value="1"></el-option>
                        <el-option :key="2" label="已通过的退款申请" :value="2"></el-option>
                        <el-option :key="3" label="已关闭的退款申请" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="流程状态">
                    <el-select v-model="tableParams.processStatus" placeholder="请选择流程状态" clearable>
                        <el-option :key="0" label="待付款" :value="0"></el-option>
                        <el-option :key="1" label="已付款待审核" :value="1"></el-option>
                        <el-option :key="2" label="审核通过待锁单" :value="2"></el-option>
                        <el-option :key="3" label="审核失败待退款" :value="3"></el-option>
                        <el-option :key="4" label="已锁单待发布" :value="4"></el-option>
                        <el-option :key="5" label="已发布" :value="5"></el-option>
                        <el-option :key="6" label="已退款" :value="6"></el-option>
                        <el-option :key="7" label="已关闭" :value="7"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="initQueryTaskClick">查询</el-button>
                    <el-button @click="resetParamsClick">重置</el-button>
                    <el-button type="primary" @click="exportOrderClick">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :data="tableData.list"
                stripe
                style="width: 100%">
                <el-table-column
                    prop="id"
                    label="ID"
                    width="60">
                </el-table-column>
                <el-table-column
                    prop="orderUserPhone"
                    label="手机号"
                    width="150">
                </el-table-column>
                <el-table-column
                    prop="orderCode"
                    label="编号"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="orderStatus"
                    label="付款状态"
                    width="80">
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.orderStatus == 1"
                            type="success"
                            effect="dark">
                            已付款
                        </el-tag>
                        <el-tag
                            v-if="scope.row.orderStatus == 4"
                            type="danger"
                            effect="dark">
                            退款中
                        </el-tag>
                        <el-tag
                            v-if="scope.row.orderStatus == 2"
                            type="danger"
                            effect="dark">
                            已退款
                        </el-tag>
                        <span v-if="scope.row.orderStatus == 0" style="color: black; font-weight: 600;">待付款</span>
                        <!-- <span v-if="scope.row.orderStatus == 1" style="color: green; font-weight: 600;">已付款</span>
                        <span v-if="scope.row.orderStatus == 4" style="color: red; font-weight: 600;">退款中</span>
                        <span v-if="scope.row.orderStatus == 2" style="color: red; font-weight: 600;">已退款</span> -->
                        <span v-if="scope.row.orderStatus == 3" style="color: gray;">超时关闭</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="orderPicUrl"
                    label="用户图片"
                    width="120">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 100px; height: 100px"
                            :src="scope.row.orderPicUrl"
                            fit="contain"
                            :preview-src-list="[scope.row.orderPicUrl]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="handTextName"
                    label="文字"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="handDateName"
                    label="上屏日期"
                    width="150">
                </el-table-column>
                <el-table-column
                    prop="handTimeName"
                    label="上屏时间"
                    width="150">
                </el-table-column>
                <el-table-column
                    prop="createdTime"
                    label="创建时间"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="payTime"
                    label="付款时间"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="refundTime"
                    label="退款时间"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="refundApplyStatus"
                    label="退款申请"
                    width="180">
                    <template slot-scope="scope">
                        <span v-if="scope.row.refundApplyStatus == 0" style="color: black; font-weight: 600;"></span>
                        <span v-if="scope.row.refundApplyStatus == 1" style="color: red; font-weight: 600;">申请退款（{{scope.row.refundApplyTypeName}}）</span>
                        <span v-if="scope.row.refundApplyStatus == 2" style="color: green; font-weight: 600;">退款申请已通过（{{scope.row.refundApplyTypeName}}）</span>
                        <span v-if="scope.row.refundApplyStatus == 3" style="color: gray;">退款申请未通过（{{scope.row.refundApplyTypeName}}）</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="processStatus"
                    label="流程状态"
                    width="180">
                    <template slot-scope="scope">
                        <span v-if="scope.row.processStatus == 0" style="color: gray; font-weight: 400;">{{ scope.row.processStatusName }}</span>
                        <span v-if="scope.row.processStatus == 1" style="color: #409EFF; font-weight: 600; font-size: 18px;">{{ scope.row.processStatusName }}</span>
                        <span v-if="scope.row.processStatus == 2" style="color: #409EFF; font-weight: 600; font-size: 18px;">{{ scope.row.processStatusName }}</span>
                        <span v-if="scope.row.processStatus == 3" style="color: red; font-weight: 600; font-size: 18px;">{{ scope.row.processStatusName }}</span>
                        <span v-if="scope.row.processStatus == 4" style="color: #67C23A; font-weight: 600; font-size: 18px;">{{ scope.row.processStatusName }}</span>
                        <span v-if="scope.row.processStatus == 5" style="color: #67C23A; font-weight: 600; font-size: 18px;">{{ scope.row.processStatusName }}</span>
                        <span v-if="scope.row.processStatus == 6" style="color: red; font-weight: 600; font-size: 18px;">{{ scope.row.processStatusName }}</span>
                        <span v-if="scope.row.processStatus == 7" style="color: black; font-weight: 400; font-size: 18px;">{{ scope.row.processStatusName }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    prop="downloadCount"
                    label="下载次数"
                    width="180">
                    <template slot-scope="scope">
                        <span v-if="scope.row.downloadCount">{{ scope.row.downloadCount }}</span>
                        <span v-else>0</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                        <el-button @click="queryOrderInfoClick(scope.row)" type="primary" size="small">详情</el-button>
                        <el-button @click="downloadOrderPicClick(scope.row)" type="warning" size="small">下载图片</el-button>
                        <el-popconfirm
                            title="确定刷新订单状态吗？建议订单状态在有延时或异常时刷新"
                            @confirm="refreshOrderClick(scope.row)"
                            >
                            <el-button slot="reference" type="info" size="small">刷新订单</el-button>
                        </el-popconfirm>
                        <!-- v-if="scope.row.orderStatus == 1 || (scope.row.orderStatus == 2 && scope.row.payAmount > scope.row.refundAmount)" -->
                        <el-button v-if="scope.row.orderStatus == 1" 
                            type="danger" 
                            size="small" 
                            @click="openRefundDialog(scope.row)">
                            退款
                        </el-button>
                        <!-- <el-popconfirm
                            title="此处仅为设置退款申请状态，如需退款请点击退款按钮"
                            :confirm-button-text="'同意退款'"
                            @confirm="setRefundApplyStatusClick(scope.row, 2)"
                            :cancel-button-text="'关闭退款'"
                            @cancel="setRefundApplyStatusClick(scope.row, 3)"
                            v-if="scope.row.refundApplyStatus == 1"
                            > -->
                            <el-button slot="reference" v-if="scope.row.refundApplyStatus == 1" type="success" size="small" @click="openRefundApplyDialog(scope.row)">处理退款申请</el-button>
                        <!-- </el-popconfirm> -->
                        <el-button size="small" 
                            v-if="scope.row.processStatus == 1 || scope.row.processStatus == 2 || (scope.row.processStatus == 3 && scope.row.orderStatus != 2) || scope.row.processStatus == 4"
                            @click="updateProcessStatusDialog(scope.row)">
                            审核
                        </el-button>
                        <!-- 测试短信 -->
                        <!-- <el-button size="small" type="danger" @click="sendOrderSmsClick(scope.row)">
                            发送短信
                        </el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <div class="form-pagination">
                <el-pagination
                    :current-page="tableData.pageNum"
                    :page-size="tableData.pageSize"
                    layout="total, prev, pager, next"
                    :total="tableData.total"
                    @prev-click="changePage(-1)"
                    @next-click="changePage(1)"
                    @current-change="handleCurrentChange">
                </el-pagination>
            </div>
        </div>

        <el-dialog
            title="处理退款申请"
            :visible.sync="dialogRefundApply.dialogVisible"
            width="30%">
            <span style="color: red; font-weight: 600; width: 100%; text-align: center; line-height: 50px;">此处仅为设置退款申请状态，如需退款请点击退款按钮</span>
            <span>
                <el-input
                    type="textarea"
                    :rows="5"
                    placeholder="请输入退款申请回复"
                    v-model="dialogRefundApply.refundApplyReply">
                </el-input>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="setRefundApplyStatusClick(3)">拒绝退款申请</el-button>
                <el-button type="primary" @click="setRefundApplyStatusClick(2)">同意退款申请</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="退款"
            :visible.sync="refundDialog.refundDialogVisible"
            width="30%"
            v-loading="loading">
            <div style="color: red; font-size: 16px; font-weight: 600; width: 100%; text-align: center; line-height: 50px;">确定退款吗？执行退款后无法回退</div>
            <div style="margin: 20px 0 0px 0;">
                <div style="margin: 20px 0 0px 0;">
                    <span>
                        订单付款总金额：<span style="color: red; font-size: 20px; font-weight: 600; margin-right: 10px">{{refundDialog.payAmount}}</span>元
                    </span>
                    ，
                    <span>
                        已退款的金额：<span style="color: red; font-size: 20px; font-weight: 600; margin-right: 10px">{{refundDialog.alreadyRefundAmount}}</span>元
                    </span>
                </div>
                <div style="margin: 20px 0 0px 0;">
                    <span>
                        本次最大可退款金额：<span style="color: red; font-size: 20px; font-weight: 600; margin-right: 10px">{{refundDialog.refundAmountMax}}</span>元
                    </span>
                    ，
                    <span>
                        最大可退款扣除30%后的金额：<span style="color: red; font-size: 20px; font-weight: 600; margin-right: 10px">{{(refundDialog.refundAmountMax * 0.7).toFixed(2)}}</span>元
                    </span>
                </div>
                
            </div>
            <div style="margin: 20px 0 20px 0; height: 50px;">
                <span style="color: red; font-size: 20px; font-weight: 600; margin-right: 10px">本次退款金额</span>
                <el-input-number v-model="refundDialog.refundAmount" :min="0" :max="refundDialog.refundAmountMax" label="请输入退款金额" :step="0.01" step-strictly></el-input-number>
                <span style="color: red; font-size: 20px; font-weight: 600; margin-right: 10px">元</span>
            </div>
            <div style="margin: 20px 0 20px 0;">
                <el-input
                    type="textarea"
                    :rows="5"
                    placeholder="请输入退款说明"
                    v-model="refundDialog.refundDesc">
                </el-input>
            </div>
            <div style="margin: 20px 0 20px 0;">
                <div style="margin: 10px 0 10px 0; font-size: 18px; font-weight: 600">
                    退款说明快捷选项
                </div>
                <div style="margin: 10px 0 10px 0;">
                    <div style="margin: 20px 0 20px 0;" v-for="(item, index) in refundDescTemplateList" :key="item.key">
                        <el-link type="primary" @click="refundDialog.refundDesc = item.value"><span style="font-size: 16px;">{{ item.value }}</span></el-link>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="refundDialog.refundDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="refundOrderClick()">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="dialogTaskInfo.newUpdateTitle" :visible.sync="dialogTaskInfo.newUpdateVisible" width="60%">
            <div class="dialog-person-body">
                    <el-form ref="form" :model="dialogTaskInfo.taskInfo" label-width="150px">
                        <el-form-item label="订单ID">
                            {{ dialogTaskInfo.taskInfo.id }}
                        </el-form-item>
                        <el-form-item label="订单编号">
                            <!-- <el-input v-model="dialogTaskInfo.taskInfo.orderCode"></el-input> -->
                            {{ dialogTaskInfo.taskInfo.orderCode }}
                        </el-form-item>
                        <el-form-item label="手机号">
                            <!-- <el-input v-model="dialogTaskInfo.taskInfo.orderUser.phone"></el-input> -->
                            {{ dialogTaskInfo.taskInfo.orderUser.phone }}
                        </el-form-item>
                        <el-form-item label="订单IP">
                            {{ dialogTaskInfo.taskInfo.clientIp }}
                        </el-form-item>
                        <el-form-item label="上屏文字">
                            <!-- <el-input v-model="dialogTaskInfo.taskInfo.handText.name"></el-input> -->
                            {{ dialogTaskInfo.taskInfo.handText.name }}
                        </el-form-item>
                        <el-form-item label="自定义文字" v-if="dialogTaskInfo.taskInfo.handText.customTextStatus == 1">
                            <div style="color: red;">{{ dialogTaskInfo.taskInfo.customText }}</div>
                        </el-form-item>
                        <el-form-item label="上屏时间">
                            <!-- <el-input v-model="dialogTaskInfo.taskInfo.handTime.name"></el-input> -->
                            {{ dialogTaskInfo.taskInfo.handTime.name }}
                        </el-form-item>
                        <el-form-item label="订单金额">
                            <!-- <el-input v-model="dialogTaskInfo.taskInfo.orderAmount"></el-input> -->
                            {{ dialogTaskInfo.taskInfo.orderAmount }} 元
                        </el-form-item>
                        <el-form-item label="订单时间">
                            <!-- <el-input v-model="dialogTaskInfo.taskInfo.createdTime"></el-input> -->
                             {{ dialogTaskInfo.taskInfo.createdTime }}
                        </el-form-item>
                        <el-form-item label="支付类型">
                            <!-- <el-input value="微信支付"></el-input> -->
                            微信支付
                        </el-form-item>
                        <el-form-item label="支付金额">
                            <!-- <el-input v-model="dialogTaskInfo.taskInfo.payAmount"></el-input> -->
                            {{ dialogTaskInfo.taskInfo.payAmount }} 元
                        </el-form-item>
                        <el-form-item label="支付时间">
                            <!-- <el-input v-model="dialogTaskInfo.taskInfo.payTime"></el-input> -->
                            {{ dialogTaskInfo.taskInfo.payTime }}
                        </el-form-item>
                        <el-form-item label="退款申请状态" v-if="dialogTaskInfo.taskInfo.refundApplyStatus > 0">
                            {{ dialogTaskInfo.taskInfo.refundApplyStatusName }}
                        </el-form-item>
                        <el-form-item label="退款申请时间" v-if="dialogTaskInfo.taskInfo.refundApplyStatus > 0">
                            {{ dialogTaskInfo.taskInfo.refundApplyTime }}
                        </el-form-item>
                        <el-form-item label="退款申请类型" v-if="dialogTaskInfo.taskInfo.refundApplyStatus > 0">
                            {{ dialogTaskInfo.taskInfo.refundApplyTypeName }}
                        </el-form-item>
                        <el-form-item label="退款申请描述" v-if="dialogTaskInfo.taskInfo.refundApplyStatus > 0">
                            {{ dialogTaskInfo.taskInfo.refundApplyDesc }}
                        </el-form-item>
                        <el-form-item label="退款申请电话" v-if="dialogTaskInfo.taskInfo.refundApplyStatus > 0">
                            {{ dialogTaskInfo.taskInfo.refundApplyPhone }}
                        </el-form-item>
                        <el-form-item label="退款申请回复" v-if="dialogTaskInfo.taskInfo.refundApplyStatus > 0">
                            {{ dialogTaskInfo.taskInfo.refundApplyReply }}
                        </el-form-item>
                        <el-form-item label="退款金额">
                            <!-- <el-input v-model="dialogTaskInfo.taskInfo.refundAmount"></el-input> -->
                             {{ dialogTaskInfo.taskInfo.refundAmount }} 元
                        </el-form-item>
                        <el-form-item label="退款说明">
                             {{ dialogTaskInfo.taskInfo.refundDesc }}
                        </el-form-item>
                        <el-form-item label="退款时间">
                            <!-- <el-input v-model="dialogTaskInfo.taskInfo.refundTime"></el-input> -->
                             {{ dialogTaskInfo.taskInfo.refundTime }}
                        </el-form-item>
                        <el-form-item label="订单图片">
                            <el-image
                                style="width: 100px; height: 100px"
                                :src="dialogTaskInfo.taskInfo.orderPicUrl"
                                fit="fit"
                                :preview-src-list="[dialogTaskInfo.taskInfo.orderPicUrl]">
                            </el-image>
                        </el-form-item>
                        <el-form-item label="预制图片" v-if="dialogTaskInfo.taskInfo.handOrderFile">
                            <el-link type="primary">{{ dialogTaskInfo.taskInfo.orderPicUrl }}</el-link>
                        </el-form-item>
                        <el-form-item label="上部图片" v-if="dialogTaskInfo.taskInfo.handOrderFile">
                            <el-link type="primary">{{ dialogTaskInfo.taskInfo.handOrderFile.upPicUrl }}</el-link>
                        </el-form-item>
                        <el-form-item label="下部图片" v-if="dialogTaskInfo.taskInfo.handOrderFile">
                            <el-link type="primary">{{ dialogTaskInfo.taskInfo.handOrderFile.downPicUrl }}</el-link>
                        </el-form-item>
                        <el-form-item label="完整图片" v-if="dialogTaskInfo.taskInfo.handOrderFile">
                            <el-link type="primary">{{ dialogTaskInfo.taskInfo.handOrderFile.completePicUrl }}</el-link>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="dialogTaskInfo.newUpdateVisible = false">关闭</el-button>
                        </el-form-item>
                    </el-form>
                </div>
        </el-dialog>

        <el-dialog title="图片下载" :visible.sync="downloadDialog.showDownloadDialog" width="30%">
            <div class="dialog-person-body">
                    <el-form ref="form" :model="downloadDialog" label-width="80px">
                        <el-form-item label="用户图片">
                            <!-- <el-input :href="downloadDialog.orderPicUrl">用户图片</el-input> -->
                            <el-link type="primary" @click="this.window.open(downloadDialog.orderPicUrl)">下载</el-link>
                        </el-form-item>
                        <el-form-item label="预制图片">
                            <!-- <el-link type="primary">{{ downloadDialog.purePicUrl }}</el-link> -->
                            <el-link type="primary" @click="this.window.open(downloadDialog.purePicUrl)">下载</el-link>
                        </el-form-item>
                        <el-form-item label="上部图片">
                            <!-- <el-link type="primary">{{ downloadDialog.upPicUrl }}</el-link> -->
                            <el-link type="primary" @click="this.window.open(downloadDialog.upPicUrl)">下载</el-link>
                        </el-form-item>
                        <el-form-item label="下部图片">
                            <!-- <el-link type="primary">{{ downloadDialog.downPicUrl }}</el-link> -->
                            <el-link type="primary" @click="this.window.open(downloadDialog.downPicUrl)">下载</el-link>
                        </el-form-item>
                        <el-form-item label="完整图片">
                            <!-- <el-link type="primary">{{ downloadDialog.completePicUrl }}</el-link> -->
                            <el-link type="primary" @click="this.window.open(downloadDialog.completePicUrl)">下载</el-link>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="downloadDialog.showDownloadDialog = false">关闭</el-button>
                        </el-form-item>
                    </el-form>
                </div>
        </el-dialog>

        <el-dialog
            title="流程状态"
            :visible.sync="dialogProcessStatus.dialogVisible"
            width="30%">
            <span>是否变更流程状态？</span>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="updateProcessStatusClick(0)">待审核</el-button> -->
                <el-button v-if="dialogProcessStatus.orderDetail.processStatus == 1 || dialogProcessStatus.orderDetail.processStatus == 3" type="primary" @click="updateProcessStatusClick(2)">审核通过待锁单</el-button>
                <el-button v-if="dialogProcessStatus.orderDetail.processStatus == 1" type="danger" @click="updateProcessStatusClick(3)">审核失败待退款</el-button>
                <el-button v-if="dialogProcessStatus.orderDetail.processStatus == 2" type="success" @click="updateProcessStatusClick(4)">锁单待发布</el-button>
                <el-button v-if="dialogProcessStatus.orderDetail.processStatus == 4" type="success" @click="updateProcessStatusClick(5)">已发布</el-button>
                <!-- <el-button @click="updateProcessStatusClick(7)">已关闭</el-button> -->
            </span>
        </el-dialog>
    </div>
</template>

<script>
import NProgress from 'nprogress'
import { queryOrderByPageApi, queryOrderByIdApi, 
    refundOrderByIdApi, downloadOrderPicApi, refreshOrderByIdApi, 
    setRefundApplyStatusApi, setProcessStatusApi, sendOrderSmsApi,
    exportOrderExcelApi
} from '@/api/api';

    export default {
        components: { 
        },
        data() {
            return {
                tableParams: {
                    orderUserPhone: '',
                    orderCode: '',
                    orderStatus: '',
                    createdTimes: [],
                    payTimes: [],
                    refundTimes: [],
                    orderBy: '',
                    refundApplyStatus: '',
                    processStatus: '',
                    // handTimes: [],
                    handDates: [],
                },
                tableData: {
                    list: [],
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                },
                dialogTaskInfo: {
                    newUpdateTitle: '新增任务',
                    newUpdateVisible: false,
                    taskInfo: {
                        orderUser: {},
                        handText: {},
                        handTime: {},
                        handOrderFile: {},
                    }
                },
                downloadDialog: {
                    showDownloadDialog: false,
                    orderPicUrl: '',
                    purePicUrl: '',
                    upPicUrl: '',
                    downPicUrl: '',
                    completePicUrl: '',
                },
                adminType: 2,
                loading: false,
                downloading: false,
                refundDialog: {
                    refundDialogVisible: false,
                    refundOrderId: null,
                    // 付款金额
                    payAmount: 0,
                    // 已经退款的金额
                    alreadyRefundAmount: 0,
                    // 本次最大退款金额
                    refundAmountMax: 0,
                    // 本次退款金额
                    refundAmount: 0,
                    refundDesc: '',
                },
                dialogProcessStatus: {
                    dialogVisible: false,
                    orderId: null,
                    orderDetail: {},
                },
                dialogRefundApply: {
                    dialogVisible: false,
                    orderId: null,
                    refundApplyReply: '',
                },
                refundDescTemplateList: [
                    {key: '1', value: '用户退款申请通过'},
                    {key: '2', value: '本次活动只针对游客上大屏，不开放品牌广告与名人明星宣传投放'},
                    {key: '3', value: '照片中含有品牌LOGO，不适宜大屏播放'},
                    {key: '4', value: '照片精度不够，不符大屏播放要求'},
                    {key: '5', value: '暂未正式运营'},
                ]
            }
        },
        filters: {
        },
        methods: {
            init(){
                const orgPath = this.$route.path
                // this.$router.push({ path: '/task_mgr/task_sub_mgr', query:{taskId:1, orgPath: orgPath} });
                let user = sessionStorage.getItem('user');
                this.adminType = JSON.parse(user).adminType
                this.queryTaskClick()                
            },
            initQueryTaskClick(){
                this.tableData.pageNum = 1
                this.tableData.pageSize = 10
                this.queryTaskClick()
            },
            queryTaskClick(){
                // 查询
                this.loading = true
                NProgress.start();
                let params = {
                    ...this.buildQueryParams(this.tableParams), 
                    pageNum: this.tableData.pageNum, 
                    pageSize: this.tableData.pageSize, 
                }
                queryOrderByPageApi(params).then(data => {
                    this.tableData = data.result
                    this.tableData.total = Number.parseInt(this.tableData.total)
                    NProgress.done();
                    this.loading = false
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                    this.loading = false
                });
            },
            resetParamsClick(){
                this.tableParams.orderUserPhone = ''
                this.tableParams.orderCode = ''
                this.tableParams.orderStatus = ''
                this.tableParams.createdTimes = []
                this.tableParams.payTimes = []
                this.tableParams.refundTimes = []
                // this.tableParams.handTimes = []
                this.tableParams.handDates = []
                this.tableParams.orderBy = ''
                this.tableParams.refundApplyStatus = ''
                this.tableParams.processStatus = ''
                this.tableData.pageNum = 1
                this.tableData.pageSize = 10
            },
            buildQueryParams(tableParams){
                let newParams = {
                    ...this.tableParams
                }
                if (tableParams.createdTimes && tableParams.createdTimes[0]) {
                    newParams.startCreatedTime = tableParams.createdTimes[0]
                }
                if (tableParams.createdTimes && tableParams.createdTimes[1]) {
                    newParams.endCreatedTime = tableParams.createdTimes[1]
                }
                if (tableParams.payTimes && tableParams.payTimes[0]) {
                    newParams.startPayTime = tableParams.payTimes[0]
                }
                if (tableParams.payTimes && tableParams.payTimes[1]) {
                    newParams.endPayTime = tableParams.payTimes[1]
                }
                if (tableParams.refundTimes && tableParams.refundTimes[0]) {
                    newParams.startRefundTime = tableParams.refundTimes[0]
                }
                if (tableParams.refundTimes && tableParams.refundTimes[1]) {
                    newParams.endRefundTime = tableParams.refundTimes[1]
                }
                // if (tableParams.handTimes && tableParams.handTimes[0]) {
                //     newParams.startHandTime = tableParams.handTimes[0]
                // }
                // if (tableParams.handTimes && tableParams.handTimes[1]) {
                //     newParams.endHandTime = tableParams.handTimes[1]
                // }
                if (tableParams.handDates && tableParams.handDates[0]) {
                    newParams.startHandDate = tableParams.handDates[0]
                }
                if (tableParams.handDates && tableParams.handDates[1]) {
                    newParams.endHandDate = tableParams.handDates[1]
                }
                return newParams
            },
            insertTaskClick(){
                this.dialogTaskInfo.newUpdateTitle = '新增任务'
                this.dialogTaskInfo.newUpdateVisible = true
                this.taskInfo = {
                    name: '',
                    code: '',
                    desc: '',
                }
            },
            queryOrderInfoClick(row){
                // 详情
                this.loading = true
                NProgress.start();
                let params = {
                    ...row
                }
                queryOrderByIdApi(params).then(data => {
                    NProgress.done();
                    this.loading = false
                    console.log("订单详情", data);
                    console.log("this", this);
                    this.dialogTaskInfo.newUpdateTitle = '订单详情'
                    this.dialogTaskInfo.newUpdateVisible = true
                    this.dialogTaskInfo.taskInfo = data.result
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                    this.loading = false
                });
                
            },
            deleteTaskClick(row){
                // 删除
                NProgress.start();
                let params = {
                    ...row
                }
                deleteTaskByIdApi(params).then(data => {
                    this.$message.success("删除成功")
                    
                    this.resetParamsClick()
                    this.queryTaskClick()
                    NProgress.done();
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                });
            },
            changePage(index){
                console.log("翻页", index);
                this.tableData.pageNum += index
                this.queryTaskClick()
            },
            handleCurrentChange(data){
                this.tableData.pageNum = data
                this.queryTaskClick()
            },
            newUpdateTaskClick(){
                if (this.dialogTaskInfo.taskInfo.id) {
                    // 更新
                    NProgress.start();
                    let params = {
                        ...this.dialogTaskInfo.taskInfo
                    }
                    updateTaskByIdApi(params).then(data => {
                        this.$message.success("更新成功")
                        this.dialogTaskInfo.newUpdateVisible = false
                        this.resetParamsClick()
                        this.queryTaskClick()
                        NProgress.done();
                    }).catch(error => {
                        this.$message.error(error.message);
                        NProgress.done();
                    });
                } else {
                    // 新增
                    NProgress.start();
                    let params = {
                        ...this.dialogTaskInfo.taskInfo
                    }
                    saveTaskApi(params).then(data => {
                        this.$message.success("新增成功")
                        this.dialogTaskInfo.newUpdateVisible = false
                        this.resetParamsClick()
                        this.queryTaskClick()
                        NProgress.done();
                    }).catch(error => {
                        this.$message.error(error.message);
                        NProgress.done();
                    });
                }
            },
            buildMgrClick(data){
                this.$router.push({ path: '/task_mgr/task_sub_mgr', query:{taskId:data.id} });
            },
            refreshOrderClick(row){
                // 刷新订单状态
                this.loading = true
                NProgress.start();
                let params = {
                    ...row
                }
                refreshOrderByIdApi(params).then(data => {
                    this.$message.success("刷新完成")
                    
                    // this.resetParamsClick()
                    this.queryTaskClick()
                    NProgress.done();
                    this.loading = false
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                    this.loading = false
                });
            },
            refundOrderClick(){
                let tempOrderId = this.refundDialog.refundOrderId
                let tempRefundDesc = this.refundDialog.refundDesc
                let tempRefundAmount = this.refundDialog.refundAmount
                let tempRefundAmountMax = this.refundDialog.refundAmountMax
                console.log("refundOrderClick", tempOrderId, tempRefundDesc, tempRefundAmount, tempRefundAmountMax);
                
                if (!tempOrderId) {
                    this.$message.error("请选择订单")
                    return
                }
                if (!tempRefundAmount || tempRefundAmount < 0.01) {
                    this.$message.error("本次退款金额必须大于等于0.01元")
                    return
                }
                if (tempRefundAmount > tempRefundAmountMax) {
                    this.$message.error("本次退款金额不能大于最大可退款金额")
                    return
                }

                // 退款
                this.loading = true
                NProgress.start();
                let params = {
                    id: tempOrderId,
                    refundDesc: tempRefundDesc,
                    refundAmount: tempRefundAmount,
                }
                refundOrderByIdApi(params).then(data => {
                    this.$message.success("退款成功")
                    
                    // this.resetParamsClick()
                    this.queryTaskClick()
                    NProgress.done();
                    this.loading = false
                    this.refundDialog.refundDialogVisible = false
                    this.refundDialog.refundOrderId = null
                    this.refundDialog.payAmount = 0
                    this.refundDialog.alreadyRefundAmount = 0
                    this.refundDialog.refundAmountMax = 0
                    this.refundDialog.refundAmount = 0
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                    this.loading = false
                });
            },
            openRefundApplyDialog(row){
                this.dialogRefundApply.dialogVisible = true
                this.dialogRefundApply.orderId = row.id
            },
            setRefundApplyStatusClick(refundApplyStatus){
                // 设置退款申请状态
                this.loading = true
                NProgress.start();
                let params = {
                    refundApplyStatus: refundApplyStatus,
                    id: this.dialogRefundApply.orderId,
                    refundApplyReply: this.dialogRefundApply.refundApplyReply,
                }
                
                setRefundApplyStatusApi(params).then(data => {
                    this.$message.success("退款申请已处理")
                    this.dialogRefundApply.dialogVisible = false
                    
                    // this.resetParamsClick()
                    this.queryTaskClick()
                    NProgress.done();
                    this.loading = false
                }).catch(error => {
                    this.$message.error(error.message);
                    this.dialogRefundApply.dialogVisible = false
                    NProgress.done();
                    this.loading = false
                });
            },
            downloadOrderPicClick(row){
                // 下载图片
                this.downloading = true
                NProgress.start();
                let params = {
                    ...row
                }
                downloadOrderPicApi(params).then(data => {
                    // this.$message.success("退款成功")
                    
                    // this.resetParamsClick()
                    // this.queryTaskClick()
                    NProgress.done();
                    this.downloading = false

                    this.downloadDialog.showDownloadDialog = true
                    this.downloadDialog.orderPicUrl = data.result.orderPicUrl
                    this.downloadDialog.purePicUrl = data.result.purePicUrl
                    this.downloadDialog.upPicUrl = data.result.upPicUrl
                    this.downloadDialog.downPicUrl = data.result.downPicUrl
                    this.downloadDialog.completePicUrl = data.result.completePicUrl
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                    this.downloading = false
                });
            },
            openRefundDialog(data){
                console.log('openRefundDialog', data);
                
                this.refundDialog.refundOrderId = data.id
                this.refundDialog.refundDialogVisible = true
                this.refundDialog.payAmount = data.payAmount
                this.refundDialog.alreadyRefundAmount = data.refundAmount ? data.refundAmount : 0
                this.refundDialog.refundAmountMax = (this.refundDialog.payAmount - this.refundDialog.alreadyRefundAmount).toFixed(2) * 1
                // this.refundDialog.refundAmount = ((this.refundDialog.payAmount - this.refundDialog.alreadyRefundAmount) * 0.7).toFixed(2) * 1
                this.refundDialog.refundAmount = 0
            },
            updateProcessStatusDialog(data){
                console.log('updateProcessStatusDialog', data);
                
                this.dialogProcessStatus.dialogVisible = true
                this.dialogProcessStatus.orderId = data.id
                this.dialogProcessStatus.orderDetail = data
            },
            updateProcessStatusClick(processStatus){
                console.log('updateProcessStatusClick', this.dialogProcessStatus);
                // 更新处理状态
                this.loading = true
                NProgress.start();
                let params = {
                    id: this.dialogProcessStatus.orderId,
                    processStatus: processStatus
                }
                setProcessStatusApi(params).then(data => {
                    this.$message.success("设置成功")
                    NProgress.done();
                    this.loading = false
                    this.dialogProcessStatus.dialogVisible = false
                    this.dialogProcessStatus.orderId = null
                    // this.dialogProcessStatus.orderDetail = {}
                    this.queryTaskClick()
                    if (processStatus == 3){
                        // 审批失败待退款
                        this.openRefundDialog(this.dialogProcessStatus.orderDetail)
                    }
                }).catch(error => {
                    this.$message.error(error.message);
                    NProgress.done();
                    this.loading = false
                });
            },
            sendOrderSmsClick(row){
                // 发送短信
                this.loading = true
                NProgress.start();
                let params = {
                    id: row.id,
                    processStatus: 4
                }
                sendOrderSmsApi(params).then(data => {
                    this.$message.success("短信发送成功")
                    console.log('短信发送成功:', data);
                    NProgress.done();
                    this.loading = false
                }).catch(error => {
                    this.$message.error("短信发送失败");
                    console.log('短信发送失败:', error);
                    NProgress.done();
                    this.loading = false
                })
            },
            exportOrderClick(){
                // 导出订单
                this.loading = true
                NProgress.start();
                let params = {
                    ...this.buildQueryParams(this.tableParams), 
                }
                exportOrderExcelApi(params).then(data => {
                    this.$message.success("导出成功")
                    console.log('导出成功:', data);
                    NProgress.done();
                    this.loading = false
                    window.open(data.result)
                }).catch(error => {
                    this.$message.error("导出失败")
                    console.log('导出失败:', error);
                    NProgress.done();
                    this.loading = false
                })
            }
        },
        mounted() {
            this.init()
        }
    }

</script>

<style lang="scss" scoped>
.desktop-main {
    width: calc(100% - 40px);
    padding: 20px;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
}
</style>


// WEBPACK FOOTER //
// order_mgr.vue?c469ab08